import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['list', 'offcanvas'];

  connect() {
    // Cache targets before body.append: after the move they leave this.element's Stimulus scope.
    this.card = this.element.closest('.card-product');
    this.list = this.listTarget;
    this.offcanvas = this.offcanvasTarget;
    this.onShow = () => this.open();
    this.onHidden = () => this.close();
    this.offcanvas.addEventListener('show.bs.offcanvas', this.onShow);
    this.offcanvas.addEventListener('hidden.bs.offcanvas', this.onHidden);
    // Portal sheet to body for root z-index scale; never append this.element (Stimulus reconnect loop).
    document.body.append(this.offcanvas);
  }

  disconnect() {
    this.close();
    this.offcanvas.removeEventListener('show.bs.offcanvas', this.onShow);
    this.offcanvas.removeEventListener('hidden.bs.offcanvas', this.onHidden);
    this.offcanvas.remove();
  }

  open() {
    this.card?.classList.add('wishlist-selector-card-offcanvas-open');
    this.list.reload();
  }

  close() {
    this.card?.classList.remove('wishlist-selector-card-offcanvas-open');
  }
}
